// src/store/slices/columnVisibilitySlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ColumnVisibilityState {
    pages: {
        [key: string]: string[];
    };
}

interface ToggleColumnPayload {
    page: string;
    columnId: string;
}

interface SetHiddenColumnsPayload {
    page: string;
    hiddenColumns: string[];
}

const initialState: ColumnVisibilityState = {
    pages: {
        countries: ['sr', 'countryName', 'countryCode', 'isActive', 'actions'],
        division: ['sr', 'divisionName', 'divisionCode', 'isActive', 'action'],
        expenseVoilation: ['sr', 'fieldName', 'description', 'violationMessage', 'isActive', 'violationLevelVM', 'actions'],
        department: ['sr', 'departmentName', 'code', 'isActive', 'actions'],
        designation: ['sr', 'name', 'roleName', 'isActive', 'createdOn', 'createdByName', 'modifiedOn', 'modifiedByName', 'actions'],
        locations: ['sr', 'locationName', 'locationCode', 'address', 'latitude', 'longitude', 'isActive', 'updatedOn', 'createdAt', 'createdBy', 'updatedBy', 'description', 'actions'],
        expenseCategories: ['sr', 'expenseType', 'categories', 'actions', 'glCode', 'status', 'description'],
        flexBudget: ['sr', 'ssId', 'bcEmployeeId', 'userType', 'user', 'allocatedBudget', 'startDate', 'endDate', 'remainingBudget', 'actions'],
        categoryBudgeting: ['sr', 'name', 'startDate', 'endDate', 'users', 'status', 'actions'],
        mileage: ['sr', 'from', 'to', 'ratePerKM', 'ratePerMi', 'actions'],
        workflow: ['sr', 'workflowName', 'workflowType', 'status', 'users', 'actions'],
        vendor: ['sr', 'name', 'description', 'address', 'phone', 'status', 'actions'],
        expenseUsers: ['sr', 'firstName', 'ssId', 'employeeId', 'bcEmployeeId', 'userOrg', 'userRole', 'userType', 'manager', 'delegateManager', 'mgrApproveMaxLimit', 'department', 'division', 'designation', 'cellphone', 'officeLocation', 'active', 'createDT','createdBy','modifiedOn','modifiedBy', 'lastLoginDt', 'lastLeaveDt', 'actions'],
        expenseDetail: ['reportId', 'expenseType', 'title', 'amount', 'createdDate', 'expenseStatus', 'manager', 'comment', 'actions'],
        expenseByCategory: ['sr', 'expenseType', 'category', 'currency', 'amount', 'vendor', 'paymentMethod', 'itemDate', 'attachment', 'source', 'description', 'reimbursableDistance', 'sS_ReportNo', 'userAccount', 'reportId', 'reportTitle', 'expenseStatusId', 'createdDT', 'createdByName', 'updatedDT', 'updatedByName', 'actions'],
        cards: ['sr', 'user', 'creditCardCatagory', 'creditCardType', 'cardNumber', 'expiryDate', 'isDeleted', 'actions'],
        approvalQueue: ['trackingId', 'userAccount', 'title', 'expenseDetail', 'amount', 'reportDate', 'expenseStatus', 'clarificationNote', 'actions'],
        expenseHistory: ['trackingId', 'expenseType', 'title', 'expenseDetail', 'amount', 'reportDate', 'expenseStatus', 'manager', 'comments', 'createdDate', 'updatedDate', 'createdBy', 'actions'],
        expenseHistoryLineItems: [
            'itemDate',
            'expenseType',
            'expenseCategory',
            'amountInOriginalCurrency',
            'unitPrice',
            'amount',
            'distance',
            'reimbursableDistance',
            'vendor',
            'paymentMethod',
            'attachment',
            'description',
            'source',
            'createdBy',
            'updatedDate',
            'actions',
        ],
        expenseLineItems: ['checkbox', 'expenseType', 'sr', 'expenseCategory', 'currency', 'amount', 'vander', 'paymentMethod', 'itemDate', 'location', 'attachment', 'description', 'source', 'reimbursableDistance', 'createdDateTime', 'updatedDate', 'actions'],
        budgetHistory: ['sr', 'user', 'allocatedBudget', 'startDate', 'endDate', 'remainingBudget', 'comments'],
        helpSupport: ['sr', 'topic', 'section', 'subject', 'description', 'assignedTo', 'requestTrackingID', 'assignedToUserDate', 'appResolutionType', 'appRequestSeverity', 'qaCompleted', 'deploymentNeeded', 'deploymentReady', 'deployed', 'estimatedDate', 'lastUpdateDate', 'status', 'requester', 'action'],
        ExpenseVoilationReport: ['trackingId', 'category', 'user', 'voilation', 'providedValues', 'receiptValues'],
        requestLogs: ['requestLogId', 'status', 'user', 'orgUserId', 'exceptionArea', 'reqMethodName', 'responseCode', 'date', 'expenseId', 'noOfRetry', 'message', 'actions'],
        categoryBudgetReport: ['sr', 'userName', 'budgetName', 'category', 'budget', 'remainingBudget', 'startDate', 'endDate'],
        accountPayableList: ['reportID', 'userAccount', 'expenseType', 'title', 'expenseDetail', 'amount', 'reportDate', 'expenseStatus', 'assignToMe', 'assignToAP', 'clarificationNote', 'submissionDate', 'approvedDate', 'createdDate', 'createdByName', 'isCorpCardReport', 'source', 'syncToBCDate', 'syncToBCStatus', 'bCExpenseCreated', 'bcExpenseCreatedDate', 'bCExpenseUpdated', 'bcExpenseUpdatedDate', 'bcPurchasedInvoiceno', 'bcCreditMemoHeaderNo', 'bcPostedPurchasedInvoiceNo', 'bcPostedPurchaseInvoiceRemainingAmount', 'bcPostedPurchaseInvoiceClosed', 'bcPurchaseHeaderNo', 'bcPostedPurchaseHeaderNo', 'bcTotalAmountPosted', 'bcTotalExpenseLineItemsCount', 'bcTotalExpenseLineItemsSplitCount', 'bcRespTotalAmountExcludingTax', 'bcRespTotalAmountIncludingTax', 'apApprovedDate', 'paidDate', 'lastBCtoSSUpdatedBy', 'lastBCtoSSUpdatedDate', 'lastUpdatedBy', 'lastUpdatedDate', 'action'],
        backupApprovers: ['checkbox', 'trackingId', 'userAccount', 'title', 'expenseDetail', 'amount', 'reportDate', 'expenseStatus', 'manager', 'clarificationNote', 'actions'],
        mergeLineItems: ['cCTransactionID', 'lineItemDetailEntityId', 'ccVendorName', 'employeeId', 'ccItemImportDate', 'ccMerchantType', 'ccItemDescription', 'cctransactionDate', 'productCode', 'ccTotalAmount', 'userFullName', 'expenseReportId', 'ssExpenseCategoryName', 'ssVendorName', 'ssItemDate', 'ssItemAmount', 'currency', 'itemDebitOrCreditIndicator', 'debitOrCreditIndicator', 'ssAttachment', 'ccReportId', 'ccAttachement', 'paymentMethod', 'ccLineItemId', 'ccSource', 'ssPaymentMethod', 'ssItemDescription', 'ssCreatedDate', 'ssLineItemId', 'ssSource', 'ccCategory', 'ssCategory'],
        bankCCFeeds: ['cCTransactionID', 'lineItemDetailEntityId', 'bankVendorName', 'employeeId', 'itemImportDate', 'merchantType', 'itemDescription', 'transactionDate', 'productCode', 'ccTotalAmount', 'userFullName', 'expenseReportId', 'expenseCategoryName', 'vendorName', 'itemDate', 'itemAmount', 'currency', 'itemDebitOrCreditIndicator', 'debitOrCreditIndicator', 'accountNumber', 'ssLineItemId'],
        userCCFeed: ['bcEmployeeId', 'cCTransactionID', 'lineItemDetailEntityId', 'bankVendorName', 'employeeId', 'itemImportDate', 'postingDate', 'processingDate', 'merchantType', 'itemDescription', 'transactionDate', 'productCode', 'ccTotalAmount', 'userFullName', 'expenseReportId', 'expenseCategoryName', 'vendorName', 'itemDate', 'itemAmount', 'currency', 'itemDebitOrCreditIndicator', 'debitOrCreditIndicator', 'accountNumber', 'fileName', 'ssLineItemId', 'isLineItemDeleted', 'syncSSToBCDateTime', 'syncSSToBCStatusCode'],
        exportReports: ['sS_ReportNo', 'amount', 'itemTransactionDate', 'receipt', 'reportStatus', 'submitted_By', 'reportDate', 'syncSSToBCDateTime', 'reportTitle', 'paymentMethod', 'assignedToName', 'chargeDepartmentCode', 'chargeDepartmentName', 'chargeLocationCode', 'chargeLocationName', 'expenseLineItemNo', 'transactionSource', 'vendorName', 'categoryName', 'splitToLocationsName', 'reportSubmittedDate', 'apApprovedDate', 'paidDate'],
        searchExpense: ['reportId', 'expenseType', 'title', 'amount', 'createdDate', 'expenseStatus', 'manager', 'comment', 'syncSSToBCDateTime', 'syncSSToBCStatusCode', 'syncToBCStatusMsg', 'bcExpenseCreated', 'bcExpenseCreatedDateTime', 'bcRespExpenseStatus', 'bcPurchasedInvoiceno', 'bcPostedPurchasedInvoiceNo', 'creditMemoNo', 'bcPostedPurchasedInvoiceNo', 'bcPostedPurchaseInvoiceRemainingAmount', 'bcPostedPurchaseInvoiceClosed', 'bcTotalAmountPosted', 'bcTotalExpenseLineItemsCount', 'bcTotalExpenseLineItemsSplitCount', 'bcRespTotalAmountExcludingTax', 'bcRespTotalAmountIncludingTax', 'approvedDate', 'paidDate', 'lastBCtoSSUpdatedBy', 'lastBCtoSSUpdatedDate', 'updatedByName', 'lastUpdatedDate', 'actions', 'user'],
        versionKeys: ['sr', 'key', 'value', 'actions'],
        reportSSAndBCDataMatch: ['itemDescription', 'debitOrCreditIndicator', 'currencyCode', 'amountInOriginalCurrency', 'unitPrice', 'cC_Amount', 'sS_Amount', 'userAccountId', 'bcEmployeeId', 'userFullName', 'trackingId', 'reportDate', 'ssReportTotalAmount', 'expenseStatus', 'itemDate', 'expenseCategory', 'vendorName', 'currencyName', 'itemDetail', 'syncSSToBCDateTime', 'syncSSToBCStatusCode', 'bcExpenseCreatedMsg', 'bcExpenseCreated', 'bcExpenseCreatedDateTime', 'bcInvoiceOrCreditMemoNo'],
       reportBankAndBCDataMatch: ['bcEmployeeId','expenseId','trackingId','expenseStatus','ssReportTotalAmount','bcSyncReportTotalAmount','bcExpenseCreated','bcExpenseCreatedDateTime','bcExpenseCreatedMsg','bcInvoiceOrCreditMemoNo','bcRespPayToVendorNumber','vendorName','expenseCategory','paymentMethod','itemDate','itemAmount'],
       SSToBCSyncFeedsReportDetail: ['bcEmployeeId','expenseId','trackingId','expenseStatus','ssReportTotalAmount','bcSyncReportTotalAmount','bcExpenseCreated','bcExpenseCreatedDateTime','bcExpenseCreatedMsg','bcInvoiceOrCreditMemoNo','bcRespPayToVendorNumber','vendorName','expenseCategory','paymentMethod','itemDate','itemAmount'],
        creditCardRequests: ['sr', 'firstName', 'department', 'designation', 'cellPhone', 'createDT', 'userType', 'expenseType', 'location', 'spendingLimit', 'division', 'ccRequestedDate', 'ccApprovedDate', 'ccRejectedDate', 'ccOrderedDate', 'modifiedOn', 'modifiedBy', 'status', 'actions'],
        acknowledgeCreditCardRequests: ['checkbox', 'firstName', 'department', 'designation', 'cellPhone', 'userType', 'expenseType', 'location', 'shipToAddress', 'spendingLimit', 'division', 'ccRequestedDate', 'ccAssignedApprover', 'ccApprovedDate', 'ccApprovedBy', 'ccRejectedDate', 'ccRejectedBy', 'ccOrderedDate', 'modifiedOn', 'modifiedBy', 'status', 'actions'],
        corpCreditCardsApprovalQueue: ['checkbox', 'firstName', 'department', 'designation', 'cellPhone', 'userType', 'expenseType', 'location', 'shipToAddress', 'spendingLimit', 'division', 'ccRequestedDate', 'ccAssignedApprover', 'ccApprovedDate', 'ccApprovedBy', 'ccRejectedDate', 'ccRejectedBy', 'ccOrderedDate', 'modifiedOn', 'modifiedBy', 'status', 'actions'],
        onboardingUserRequests: ['sr', 'firstName', 'managerEmail', 'cellPhone', 'division', 'department', 'designation', 'dayforceId', 'findAddress', 'location', 'apiOrgName', 'status', 'comments', 'createdDT', 'modifiedOn', 'approvelDT', 'requestCorporateCreaditCard', 'spendingLimit', 'actions'],
        surveyCampaigns: [
            'campaignNumber',
            'title',
            'targetPlatform',
            'startDate',
            'endDate',
            'isActive',
            'eligibleUserCount',
            'completedUserCount',
            'responseCount',
            'excludedUserCount',
            'createdOn',
            'createdByName',
            'modifiedOn',
            'modifiedByName',
            'actions',
        ],
        surveyDashboardResponses: [
            'campaignNumber',
            'orgUserId',
            'userName',
            'email',
            'role',
            'designation',
            'department',
            'lastLogin',
            'platformName',
            'question',
            'rating',
            'reasonText',
            'feedback',
            'submittedOn',
        ],
        surveyDashboardActions: [
            'campaignNumber',
            'orgUserId',
            'userName',
            'role',
            'designation',
            'department',
            'actionType',
            'question',
            'rating',
            'platformName',
            'actionTime',
            'pageName',
        ],
        mergeLineItemsV2: [
            'select',
            'order',
            'trackingId',
            // 'title' hidden by default — enable via Columns menu
            'reportStatus',
            'reportCategory',
            'invoiceDataDraftId',
            'itemDate',
            'category',
            'amount',
            'vendor',
            'paymentMethod',
            'attachment',
            'description',
            'source',
            'createdDate',
            'columnsMenu',
        ],
        orgSettingGroups: [
            'expand',
            'groupName',
            // description (Group Details) hidden by default
            'isActive',
            'createdOn',
            'createdBy',
            'modifiedOn',
            'modifiedBy',
            'actions',
        ],
        orgSettingsAll: [
            'groupName',
            'settingKey',
            'settingValue',
            'settingDetail',
            'isActive',
            'createdOn',
            'modifiedOn',
            'actions',
            // createdBy / modifiedBy (Setting Key CreatedBy/ModifiedBy) hidden by default
        ],
        // Visible by default (checked). Omit sizeMb so Size (MB) is off until user enables it.
        logFiles: ['fileName', 'createdOn', 'modifiedOn', 'sizeBytes', 'status', 'actions'],
        emailLogs: [
            'logEmailId',
            'fromEmail',
            'toEmail',
            'toEmailCC',
            'toEmailBCC',
            'subject',
            'message',
            'sentStatus',
            'created',
            'lastUpdated',
            'emailSettingType',
            'toOrgUserID',
            'userName',
            'userEmail',
            'actions',
        ],
        teamManagementActiveUsers: ['sr', 'firstName', 'department', 'designation', 'cellPhone', 'createDT', 'actions'],
        // Add other pages as needed
    }
};

const columnVisibilitySlice = createSlice({
    name: 'columnVisibility',
    initialState,
    reducers: {
        toggleColumn: (state, action: PayloadAction<ToggleColumnPayload>) => {
            const { page, columnId } = action.payload;
            if (!state.pages[page] || state.pages[page].length === 0) {
                const pageDefaults = initialState.pages[page];
                state.pages[page] = pageDefaults && pageDefaults.length > 0 ? [...pageDefaults] : [];
            }
            if (state.pages[page].includes(columnId)) {
                state.pages[page] = state.pages[page].filter(id => id !== columnId);
            } else {
                state.pages[page].push(columnId);
            }
        },
        setHiddenColumns: (state, action: PayloadAction<SetHiddenColumnsPayload>) => {
            const { page, hiddenColumns } = action.payload;
            state.pages[page] = hiddenColumns;
        }
    }
});

export const { toggleColumn, setHiddenColumns } = columnVisibilitySlice.actions;
export { initialState };
export default columnVisibilitySlice.reducer;
